import { call, put, take } from 'redux-saga/effects'

import { api } from '../../api/api'
import { apiSaga } from './sagas'

// ------------------------------------
// Action Types & Creators
// ------------------------------------
export const LOAD_NOTIFICATION_PREFERENCES = 'foodsby/preferences/LOAD_NOTIFICATION_PREFERENCES'
export const LOAD_NOTIFICATION_PREFERENCES_SUCCESS =
  'foodsby/preferences/LOAD_NOTIFICATION_PREFERENCES_SUCCESS'
export const LOAD_NOTIFICATION_PREFERENCES_FAILURE =
  'foodsby/preferences/LOAD_NOTIFICATION_PREFERENCES_FAILURE'

export const UPDATE_NOTIFICATION_PREFERENCE = 'foodsby/preferences/UPDATE_NOTIFICATION_PREFERENCE'
export const UPDATE_NOTIFICATION_PREFERENCE_SUCCESS =
  'foodsby/preferences/UPDATE_NOTIFICATION_PREFERENCE_SUCCESS'
export const UPDATE_NOTIFICATION_PREFERENCE_FAILURE =
  'foodsby/preferences/UPDATE_NOTIFICATION_PREFERENCE_FAILURE'

export const loadNotificationPreferencesStart = () => {
  return {
    type: LOAD_NOTIFICATION_PREFERENCES,
  }
}

export const loadNotificationPreferencesSuccess = notificationPreferences => {
  return {
    payload: { notificationPreferences },
    type: LOAD_NOTIFICATION_PREFERENCES_SUCCESS,
  }
}

export const loadNotificationPreferencesFailure = error => {
  return {
    error,
    type: LOAD_NOTIFICATION_PREFERENCES_FAILURE,
  }
}

export const updateNotificationPreferenceStart = notificationPreference => {
  return {
    payload: { notificationPreference },
    type: UPDATE_NOTIFICATION_PREFERENCE,
  }
}

export const updateNotificationPreferenceSuccess = () => {
  return {
    type: UPDATE_NOTIFICATION_PREFERENCE_SUCCESS,
  }
}

export const updateNotificationPreferenceFailure = error => {
  return {
    error,
    type: UPDATE_NOTIFICATION_PREFERENCE_FAILURE,
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [LOAD_NOTIFICATION_PREFERENCES]: state => {
    return {
      ...state,
      isLoadingNotificationPreferences: true,
    }
  },
  [LOAD_NOTIFICATION_PREFERENCES_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      error,
      isLoadingNotificationPreferences: false,
    }
  },
  [LOAD_NOTIFICATION_PREFERENCES_SUCCESS]: (state, action) => {
    const notificationPreferences = action.payload.notificationPreferences
    return {
      ...state,
      error: undefined,
      isLoadingNotificationPreferences: false,
      notificationPreferences,
    }
  },
  [UPDATE_NOTIFICATION_PREFERENCE]: state => {
    return {
      ...state,
      isUpdatingPreference: true,
    }
  },
  [UPDATE_NOTIFICATION_PREFERENCE_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      error,
      isUpdatingPreference: false,
      notificationPreferences: state.notificationPreferences,
    }
  },
  [UPDATE_NOTIFICATION_PREFERENCE_SUCCESS]: state => {
    return {
      ...state,
      error: undefined,
      isUpdatingPreference: false,
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}

export default function preferences(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------
export function* watchLoadNotificationPreferences() {
  while (true) {
    yield take(LOAD_NOTIFICATION_PREFERENCES)
    yield call(
      apiSaga,
      loadNotificationPreferences,
      [],
      loadNotificationPreferencesSuccess,
      loadNotificationPreferencesFailure,
    )
  }
}

export function* watchUpdateNotificationPreference() {
  while (true) {
    const {
      payload: { notificationPreference },
    } = yield take(UPDATE_NOTIFICATION_PREFERENCE)
    try {
      yield call(
        apiSaga,
        updateNotificationPreference,
        [notificationPreference],
        updateNotificationPreferenceSuccess,
        updateNotificationPreferenceFailure,
      )
    } catch (error) {
      yield put(updateNotificationPreferenceFailure(error))
    }
  }
}

export const loadNotificationPreferences = () => api.get(`/api/v1/switchboard/preferences`)
export const updateNotificationPreference = notificationPreference =>
  api.patch(`/api/v1/switchboard/preferences`, notificationPreference)
